import * as styles from './NotFound.module.css';
import { Button } from 'src/components/Button/Button.tsx';
import backArrow from 'url:../../assets/images/back-arrow-black.webp';
import searchIcon from 'url:../../assets/images/search-icon.webp';
import { useNavigate } from 'react-router-dom';

export function NotFound() {
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.searchContainer}>
        <img src={searchIcon} className={styles.menuLogo} alt="" />
      </div>

      <div className={styles.title}>{'Page not found'}</div>

      <div className={styles.message}>
        {"The page you are looking for doesn't exist.\nHere are some helpful links:"}
      </div>

      <div className={styles.buttonContainer}>
        <Button
          iconWidth={16}
          className={styles.buttonWrapperBack}
          icon={backArrow}
          variant={'light'}
          onClick={() => navigate('/')}
        >
          {'Go back'}
        </Button>

        <Button
          className={styles.buttonWrapperHome}
          variant={'primary'}
          onClick={() => navigate('/')}
        >
          {'Take me home'}
        </Button>
      </div>
    </div>
  );
}
